import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import g from 'glamorous';

import Header from '../components/header';
import Footer from '../components/footer';
import i18n from '../components/i18n';

import colors from '../utils/colors';
import generalStyles from '../utils/generalStyles';
import favicon from '../assets/imgs/favicon.ico';

import '../styles/main.scss';

const Container = g.div({
  marginLeft: 'auto',
  marginRight: 'auto',
  zIndex: 1,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  [generalStyles.mediaQueries.xxs]: {
    display: 'block'
  }
});

const MainContent = g.div({
  flex: '4',
  position: 'relative',
  [generalStyles.mediaQueries.xs]: {
    width: '100%'
  }
});

const Spacer = g.div({
  flex: '1',
  [generalStyles.mediaQueries.lg]: {
    display: 'none'
  }
});
const FooterSpacer = g.div({
  flex: '1',
  background: 'white',
  [generalStyles.mediaQueries.lg]: {
    display: 'none'
  }
});

const Wrapper = g.div({
  backgroundColor: colors.alabaster,
  paddingLeft: '2rem',
  paddingRight: '2rem',
  width: '100%',
  position: 'relative',
  [generalStyles.mediaQueries.md]: {
    padding: '0'
  }
});

const BackDecoration = g.div({
  display: 'flex',
  justifyContent: 'space-between',
  position: 'absolute',
  width: '100%',
  height: '100%',
  padding: '0 2rem',
  left: 0,
  zIndex: 0,
  [generalStyles.mediaQueries.md]: {
    padding: 0
  },
  [generalStyles.mediaQueries.xs]: {
    display: 'none'
  }
});

const DecLines = g.div({
  flex: '1',
  borderLeft: `1px solid ${colors.mischka}`,
  ':last-child': {
    borderRight: `1px solid ${colors.mischka}`
  },
  [generalStyles.mediaQueries.lg]: {
    ':last-child,:first-child': {
      display: 'none'
    }
  }
});

class TemplateWrapper extends React.Component {
  render() {
    return (
      <Wrapper>
        <BackDecoration>
          <DecLines />
          <DecLines />
          <DecLines />
          <DecLines />
          <DecLines />
          <DecLines />
        </BackDecoration>
        <Helmet>
          <title>PASCHAKIS PERIKLIS Lawyer & Law Office</title>
          <link rel="shortcut icon" type="image/png" href={favicon} />
          <link
            rel="stylesheet"
            type="text/css"
            href={`https://cloud.typography.com/7026694/7089192/css/fonts.css`}
          />
          <meta property="og:url" content="https://www.pasxakislaw.com/" />
          <meta property="og:title" content="PASCHAKIS PERIKLIS Lawyer & Law Office" />
          <meta
            property="og:description"
            content="“Pericles Paschakis and Associates” Law offices is headed by the Supreme Court Lawyer Pericles Nik. Paschakis. We maintain offices in Athens as well as in Patras and we have a wide range of associates throughout the country."
          />
          <meta
            property="og:image"
            content={`https://www.pasxakislaw.com/imgs/pasxakis-law-firm.png`}
          />
          <meta name="og:site_name" content="PASCHAKIS PERIKLIS Lawyer & Law Office" />
          <meta
            name="keywords"
            content="Περικλής Πασχάκης, Περικλής, Πασχάκης, Πάτρα, Αθήνα, δικηγόρος,ποινικό, έγκλημα, δικηγορικό γραφείο, 
                        δικηγόρος, Κολωνάκι, Σόλωνος, Αθήνα, Παρ αρειω πάγω, περικλης πασχακης, δικηγορος, δικηγορικο γραφειο, περικλης, πασχακης, 
                        Pericles Paschakis, periklis pasxakis, periklis, pasxakis, paschakis, law offices, athens, patra, patras, lawyer, offices"
          />
          <meta
            name="description"
            content="Ιστοσελιδα του Δικηγορικου Γραφειου Περικλης Πασχακης, με γραφεια στο Κολωνάκι, Αθηνα και στην Πατρα. 
                        Pericles Paschakis Law Offices Website, with offices in Athens and Patras. Periklis Pasxakis"
          />
          <meta
            name="subject"
            content="PASCHAKIS PERIKLIS Lawyer & Law Office Περικλης Πασχάκης Δικηγορικό Γραφείο"
          />
        </Helmet>
        <Container>
          <Spacer />
          <MainContent>
            <Header />
            <div>{this.props.children()}</div>
          </MainContent>
          <Spacer />
        </Container>
        <Container>
          <FooterSpacer />
          <MainContent>
            <Footer />
          </MainContent>
          <FooterSpacer />
        </Container>
      </Wrapper>
    );
  }
}

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js